import { Component, Input } from '@angular/core';

@Component({
    selector: 'pgf-how-it-works',
    templateUrl: `./how-it-works.component.html`,
    styleUrls: ['./how-it-works.component.scss']
})

export class PgfHowItWorksComponent {
  @Input() type:'pgf'|'nopgf' = 'pgf';

  public content = {
    pgf: [
      { title: 'GIVE',
        text: 'Contributing to the Donor Advised Fund is simple. After donating, you’ll receive a tax receipt within a few weeks. Copies will be available in the Documents tab of the online portal. Contact your Advisory Team to make a donation to the DAF.',
        img: '/assets/PGF/pgf-hiw1.jpg'
      },
      { title:'GROW',
        text: 'Contributions to the DAF are managed according to our Investment Policy Statement, overseen by the Nicola Wealth Private Giving Foundation Board of Directors. Investments have the potential to grow until you choose which charities to support, now or over time. Details are available under the Performance tab.',
        img: '/assets/PGF/pgf-hiw2.jpg'
      },
      { title:'GRANT',
        text: 'As the Donor Advisor to the DAF, you make recommendations on granting to your chosen Canadian registered charities or qualified donees. Grants must be a minimum of $500, with disbursement cycles every two weeks. Grants are sent electronically, and thank you letters from charities are saved in the DAF Documents tab.',
        img: '/assets/PGF/pgf-hiw3.jpg'
      },
      { title:'IMPACT',
        text: 'We aim to make your donor experience personalized, seamless, and impact-driven. For assistance in determining your charitable impact, contact your Wealth Advisor to start a conversation.',
        img: '/assets/PGF/pgf-hiw4.jpg'
      }],
    nopgf: [
      { title: 'GIVE',
        text: 'Give now, receive a tax receipt, and disburse to your favourite charities over time. Donations to a Donor Advised Fund can be made by cash or in-kind. In-kind donations such as mutual funds, stocks, bonds, real estate, or insurance policies are accepted.',
        img: '/assets/PGF/pgf-hiw1.jpg'
      },
      { title:'GROW',
        text: 'All contributions to the DAF are managed in keeping with the Foundation’s Investment Policy Statement, guided by our Board of Directors, with the potential to grow, until you decide which charities to support. Take your time; we are here to help you achieve your philanthropic goals.',
        img: '/assets/PGF/pgf-hiw2.jpg'
      },
      { title:'GRANT',
        text: 'As the Donor Advisor to the DAF, you make recommendations on when and how much to grant to your chosen charities. It’s that simple.',
        img: '/assets/PGF/pgf-hiw3.jpg'
      },
      { title:'IMPACT',
        text: 'Collectively, our donors had an incredible impact in 2023! Our generous donors disbursed $29M to over 800 charities, supporting a broad range of causes.',
        img: '/assets/PGF/pgf-hiw4.jpg'
      }]
  };
}